module.exports = __webpack_public_path__ + "media/images/flags/4x3/cod-4d75b3780549543c7f7aca450371c902.svg";